import styled from 'styled-components'
import Button from '@mui/material/Button'

export const ButtonContainer = styled(Button)`
  margin: 5px 0 10px;
`
